import { useMutation } from "@tanstack/react-query"
import { sendAccountPhoneOtp } from "@/api"

export const useSendAccountPhoneOtp = () => {
  return useMutation({
    mutationFn: (args: { phoneNumber: string, channel?: "email" }) => sendAccountPhoneOtp(args),
  })
}
